import { useRef } from 'react';
import { View } from 'foundations-components/transitional/components/View';
import { DEFAULT_POSITION_TOOLBARS } from 'LayoutBuilderUI/utils/scrollPositionUtils';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import ToolbarIconGroup from 'EmailEditorUI/components/overlays/ToolbarIconGroup';
import { jsx as _jsx } from "react/jsx-runtime";
const elementToolbarProps = {
  insetInlineEnd: '0',
  textAlign: 'end'
};
const sectionToolbarProps = {
  insetInlineStart: '-2px'
};
const ComponentToolbar = props => {
  const stopPropagation = e => e.stopPropagation();
  const toolbar = useRef(null);
  const {
    children,
    type,
    scrollPosition = `${DEFAULT_POSITION_TOOLBARS}px`,
    isReadOnlyMode = false
  } = props;
  if (isReadOnlyMode) {
    return /*#__PURE__*/_jsx(NamespaceWrapper, {
      children: /*#__PURE__*/_jsx(View, {
        position: "absolute",
        insetBlockStart: "-26px",
        onClick: stopPropagation,
        onMouseUp: stopPropagation,
        onMouseDown: stopPropagation,
        ref: toolbar
      })
    });
  }
  return /*#__PURE__*/_jsx(NamespaceWrapper, {
    children: /*#__PURE__*/_jsx(View, Object.assign({
      position: "absolute",
      insetBlockStart: scrollPosition
    }, type === 'element' ? elementToolbarProps : sectionToolbarProps, {
      onClick: stopPropagation,
      onMouseUp: stopPropagation,
      onMouseDown: stopPropagation,
      ref: toolbar,
      inlineSize: "100%",
      "data-test-id": type === 'element' ? 'element-toolbar-container' : 'section-toolbar-container',
      "data-scroll-element": "true",
      children: /*#__PURE__*/_jsx(ToolbarIconGroup, {
        "data-test-id": "component-toolbar",
        children: children
      })
    }))
  });
};
export default ComponentToolbar;